<template>
  <div class="bullets">
      <a class="bullet-item" :class="{active: i == current}" @click="select(i)" v-for="i in items" :key="`bullet-${i}`"></a>
  </div>
</template>

<script>
export default {

    props: {
        items: [Array, Number, Object],
        current: {
            type: Number,
            default: 0
        }
    },


    methods: {
        select(index) {
            this.$emit('change', index);
            this.$emit('update:current', parseInt(index))
        }
    }
}
</script>

<style>

</style>
